import React from "react"
import {Tabs} from "antd"
import {useActiveTab} from "hooks"
import {usePaymentProviderConfigs} from "hooks/usePaymentProviderConfigs"
import {LedgerTab} from "./parts"
import {ChargesTab} from "./parts/ChargesTab"
import {PaymentsTab} from "./parts/PaymentsTab"
import PaymentMethods from "./parts/PaymentMethods"
import RecurringPayments from "./parts/RecurringPayments"

const {TabPane} = Tabs

export enum StudentLedgerSubtab {
    Ledger = "ledger",
    Charges = "charges",
    Payments = "payments",
    PaymentMethods = "payment-methods",
    RecurringPayments = "recurring-payments"
}

export function StudentLedgerTab(props: {profileId?: number; userId?: number}) {
    const [activeTabKey, onChangeTab] = useActiveTab(StudentLedgerSubtab.Ledger, "studentledgertab")
    const {isStripeEnabled, isPaypalEnabled, isAuthorizeNetEnabled, isDirectEmbedEnabled} = usePaymentProviderConfigs(
        props.profileId
    )

    return (
        <div className="mt-16">
            <Tabs className="fullwidth klassSubTab" activeKey={activeTabKey} onChange={onChangeTab}>
                <TabPane tab="Ledger" key={StudentLedgerSubtab.Ledger}>
                    {activeTabKey === StudentLedgerSubtab.Ledger && <LedgerTab {...props} />}
                </TabPane>
                <TabPane tab="Charges" key={StudentLedgerSubtab.Charges}>
                    {activeTabKey === StudentLedgerSubtab.Charges && <ChargesTab {...props} />}
                </TabPane>
                <TabPane tab="Payments" key={StudentLedgerSubtab.Payments}>
                    {activeTabKey === StudentLedgerSubtab.Payments && <PaymentsTab {...props} />}
                </TabPane>
                {!!props.profileId && isStripeEnabled && (
                    <TabPane tab="Payment Methods" key={StudentLedgerSubtab.PaymentMethods}>
                        {activeTabKey === StudentLedgerSubtab.PaymentMethods && (
                            <PaymentMethods {...props} profileId={props.profileId!} />
                        )}
                    </TabPane>
                )}
                {!!props.profileId &&
                    (isStripeEnabled || isPaypalEnabled || isAuthorizeNetEnabled || isDirectEmbedEnabled) && (
                        <TabPane tab="Recurring Payments" key={StudentLedgerSubtab.RecurringPayments}>
                            {activeTabKey === StudentLedgerSubtab.RecurringPayments && (
                                <RecurringPayments {...props} profileId={props.profileId!} />
                            )}
                        </TabPane>
                    )}
            </Tabs>
        </div>
    )
}
